const mockRecipientsData = [
    {
        "token": "ecf3b95b-ee85-42a0-9062-fe30cc522853",
        "name": "Klark Kent",
        "email": "klark@kent.io",
        "lists": [
            {
                "id": 1,
                "name": "To E-Mail"
            }
        ],
        "responded_sent": "1/2",
        "unsubscribed_from": "",
        "sending_allowed": true
    },
    {
        "token": "bc1a4c57-020f-4622-a805-2c1e84772684",
        "name": "Daniel Lee",
        "email": "daniel@lee.com",
        "lists": [
            {
                "id": 1,
                "name": "To E-Mail"
            }
        ],
        "responded_sent": "2/2",
        "unsubscribed_from": "",
        "sending_allowed": true
    },
    {
        "token":"f32a1c8b-3b4a-4b5a-833f-a8b7f2c8d9e1",
        "name":"Alice Smith",
        "email":"alice@smith.com",
        "lists":[
            {
                "id":2,
                "name":"Newsletters"
            }
        ],
        "responded_sent":"2/5",
        "unsubscribed_from":"",
        "sending_allowed":true
    },
    {
        "token":"d5e9f8b2-6ae1-4d0a-9b2e-3b5a7a9f3b79",
        "name":"Bob Johnson",
        "email":"bob@johnson.com",
        "lists":[
            {
                "id":3,
                "name":"VIP Customers"
            }
        ],
        "responded_sent":"1/3",
        "unsubscribed_from":"",
        "sending_allowed":true
    },
    {
        "token":"9c5d77f3-6b40-4c6b-8d64-4a2b9f2a3b4f",
        "name":"Cindy Lee",
        "email":"cindy@lee.com",
        "lists":[
            {
                "id": 1,
                "name": "To E-Mail"
            },
            {
                "id":4,
                "name":"Promo Invites"
            }
        ],
        "responded_sent":"3/3",
        "unsubscribed_from":"Newsletters",
        "sending_allowed":true
    },
    {
        "token":"7e4b8ada-ee4f-476c-9e98-11a5c2f4d5e3",
        "name":"David Park",
        "email":"david@park.com",
        "lists":[
            {
                "id":3,
                "name":"VIP Customers"
            }
        ],
        "responded_sent":"3/4",
        "unsubscribed_from":"Product Updates",
        "sending_allowed":true
    },
    {
        "token":"ab1c23d4-56e7-890f-gh12-i34j56k78lm9",
        "name":"Emma Watson",
        "email":"emma@watson.com",
        "lists":[
            {
                "id":5,
                "name":"Product Updates"
            }
        ],
        "responded_sent":"6/6",
        "unsubscribed_from":"",
        "sending_allowed":true
    },
    {
        "token":"cd3ef456-7gh8-9i01-jk23-lm45n678op90",
        "name":"Frank Young",
        "email":"frank@young.com",
        "lists":[
            {
                "id":1,
                "name":"To E-Mail"
            }
        ],
        "responded_sent":"6/7",
        "unsubscribed_from":"Promo Invites",
        "sending_allowed":true
    },
    {
        "token": "mn23op45-67qr-89st-01uv-wx23yz45ab67",
        "name": "Jack Brown",
        "email": "jack@brown.com",
        "lists": [
            {
                "id": 3,
                "name": "VIP Customers"
            }
        ],
        "responded_sent": "9/12",
        "unsubscribed_from": "",
        "sending_allowed": true
    },
    {
        "token": "q7r8s9t0-u1v2-w3x4-y5z6-a7b8c9d0e1f2",
        "name": "Mike Turner",
        "email": "mike@turner.com",
        "lists": [
            {
                "id": 5,
                "name": "Product Updates"
            }
        ],
        "responded_sent": "2/4",
        "unsubscribed_from": "Product Updates",
        "sending_allowed": true
    },
]
export default mockRecipientsData;